import { makeStyles } from '@material-ui/core'

export const useLocationStepStyles = makeStyles(() => ({
  withoutLine: {
    marginTop: 'var(--vel-fixed-spacing-07)',
  },
}))
